package team.platforma.chat_data.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class MessageResponse(
   @SerialName("chat_id") val chat_id: Long,
   @SerialName("content") val content: String,
//   @SerialName("created_at") val created_at: String,
//   @SerialName("deleted_at") val deleted_at: String,
//   @SerialName("message_id") val message_id: Long,
   @SerialName("role") val role: String
)